export default "__VITE_ASSET__9WA5AkIb__"